import React from "react";
import { FormikProps } from "formik";
import MenuItem from "@material-ui/core/MenuItem";
import CustomDropdown, { CustomDropdownProps } from "../../../components/Input/CustomDropdown";
import { AproeProjectForm, SelectOption } from "./models";

type AproeDropdownProps<T extends string> = {
  fieldIdentifier: keyof AproeProjectForm;
  options: SelectOption<T>[];
  FormikProps: FormikProps<AproeProjectForm>;
} & CustomDropdownProps;

function AproeDropdown<T extends string>(props: AproeDropdownProps<T>) {
  const { fieldIdentifier, options, FormikProps, ...restProps } = props;
  const { errors, values, touched } = FormikProps;
  return (
    <CustomDropdown
      {...restProps}
      error={!!(errors[fieldIdentifier] && touched[fieldIdentifier])}
      helperText={touched[fieldIdentifier] && errors[fieldIdentifier] ? errors[fieldIdentifier] : ""}
      name={fieldIdentifier}
      value={values[fieldIdentifier]}
    >
      {options.map((o) => (
        <MenuItem key={o.value} value={o.value}>
          {o.name}
        </MenuItem>
      ))}
    </CustomDropdown>
  );
}

export default AproeDropdown;
